import React from 'react';

const LabelForm = ({ children, ...rest }) => {
	return <label className="text-sm cursor-pointer" {...rest}>{children}</label>;
};
export default LabelForm;